const styles = {
  wrapper: `flex flex-col overflow-hidden rounded-2 md:rounded-4`,
  imageWrapper: `relative`,
  boxContent: 'p-4 md:p-6',
};

export default styles;
